import { styled } from 'styled-components';
import { SkapaChoice, SkapaTokens } from '@inter-ikea-guida/skapa';
export const StyledGridChoice = styled(SkapaChoice) `
  display: flex;
  flex-wrap: wrap;
  gap: ${SkapaTokens.space100};
  margin-bottom: ${SkapaTokens.space100};

  > li {
    flex: 1;
  }

  > li.choice__list-item {
    margin: 0;
  }
`;
//# sourceMappingURL=ChoiceStyles.js.map